import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'DeleteCustomer',
  properties: {
    customerId: prop(String),
  },
});
